export function getDashboardPath(user) {
  if (['admin', 'provider', 'client'].includes(user?.role)) {
    return '/dashboard';
  }
  return '/dashboard';
}

